import { PlainMessage } from "@bufbuild/protobuf";
import { Section } from "@egocentric-systems/ts-apis/booking_gateway/v1/events_pb";
import { useMemo } from "react";
import {
  getMaxPriceValue,
  isPriceWithinRange,
} from "~/app/tickets/[eventId]/_components/helpers";
import { usePricesSearchParams } from "~/app/tickets/[eventId]/_components/Filter/hooks";

export function useFilteredSections(
  sections: Array<PlainMessage<Section>>,
): Array<PlainMessage<Section>> {
  const [{ min, max, category }] = usePricesSearchParams();

  const filtered = useMemo(() => {
    return min === null && max === null
      ? sections
      : sections.filter((section) => {
          if (category && category !== section.priceGroupId) {
            return false;
          }

          const maxPriceAsNumber = getMaxPriceValue(section.prices);

          return isPriceWithinRange(maxPriceAsNumber, min ?? "", max ?? "");
        });
  }, [sections, min, max, category]);

  return filtered.filter((section) => section.prices.length !== 0);
}
